import { fetchRequestWithTypes } from './index.js';

// Verifies user email address via token confirmation.

export const POST_EMAIL_VERIFICATION_REQUEST = 'POST_EMAIL_VERIFICATION_REQUEST';
export const POST_EMAIL_VERIFICATION_SUCCESS = 'POST_EMAIL_VERIFICATION_SUCCESS';
export const POST_EMAIL_VERIFICATION_ERRORED = 'POST_EMAIL_VERIFICATION_ERRORED';

export const postEmailVerification = ({ token }) =>
	fetchRequestWithTypes({
		types: [
			POST_EMAIL_VERIFICATION_REQUEST,
			POST_EMAIL_VERIFICATION_SUCCESS,
			POST_EMAIL_VERIFICATION_ERRORED,
		],
		request: {
			method: 'POST',
			path: `/apis/api/v1/users/:uuid/email_verification/verify`,
			body: {
				code: token,
			},
		},
	});
